module.exports = __webpack_public_path__ + "img/riviera-fish.28b34fc8.jpg";